<template>
  <div>
    <!-- <search-section /> -->
    <div class="container">
      <div class="row g-4 mt-0">
        <div class="col-lg-3 d-none d-lg-block">
          <!-- Filters -->
          <div class="filter-section">
            <div class="card">
              <div class="card-body">
                <h2 class="filter-title mb-4">Categories</h2>

                <div class="filter-options">
                  <div
                    class="category-link"
                    v-for="(category, index) in categories"
                    :key="`category-${index}`"
                  >
                    <router-link
                      :to="'/category/?c=' + category.slug"
                      style="text-decoration: none"
                    >
                      <span class="category-text">
                        <i :class="category.icon" class="category-icon"></i>
                        {{ category.name }}
                      </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h2 class="filter-title mb-4">Filter by Price</h2>

                <div class="price-filter">
                  <div class="price-values d-flex justify-content-between mb-2">
                    <span>৳ {{ minPrice }}</span>
                    <span>৳ {{ maxPrice }}</span>
                  </div>
                  <div class="range-slider">
                    <div class="range-track"></div>
                    <div class="range-track-active" :style="activeTrackStyle"></div>
                    <input
                      type="range"
                      :min="PRICE_MIN"
                      :max="PRICE_MAX"
                      step="100"
                      v-model.number="minPrice"
                      @input="onMinInput"
                      class="range-input range-min"
                    />
                    <input
                      type="range"
                      :min="PRICE_MIN"
                      :max="PRICE_MAX"
                      step="100"
                      v-model.number="maxPrice"
                      @input="onMaxInput"
                      class="range-input range-max"
                    />
                  </div>
                  <button
                    class="btn apply-filter-btn mt-4 w-100"
                    @click="applyPriceFilter"
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h2 class="filter-title mb-4">Shop By Concern</h2>

                <div class="filter-options">
                  <div
                    class="category-link"
                    v-for="(concern, i) in concerns"
                    :key="`concern-${i}`"
                  >
                    <router-link
                      :to="{ path: '/category', query: { c: concern.slug } }"
                      style="text-decoration: none"
                    >
                      <span class="category-text">{{ concern.label }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div v-if="isLoading" class="text-center m-5">
            <div class="spinner-border mb-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p>Loading amazing products...</p>
          </div>
          <!-- Product Section -->
          <div v-else class="product-section">
            <div v-if="productList.length" class="row g-4">
              <!-- Product Card -->
              <div
                v-for="(product, i) in productList"
                :key="`product-${i}`"
                class="col-6 col-md-3"
              >
                <div class="product-card">
                  <router-link
                    :to="'/product/' + product._id + `/${slugify(product.title)}`"
                    style="text-decoration: none"
                  >
                    <img
                      :src="
                        product.images?.length
                          ? `${BASE_IMAGE_PREFIX}/${product.images[0]}`
                          : `${PLACEHOLDER_IMAGE}`
                      "
                      alt="Product image"
                      class="product-image"
                    />
                    <h5 class="product-title">{{ product.title }}</h5>
                  </router-link>
                  <div
                    v-if="product.productCategory !== 'stationary'"
                    class="product-brand"
                  >
                    {{ product.brand }}
                  </div>
                  <div class="product-price" v-if="product.minVariant">
                    <span v-if="product.minVariant.isOnSale && product.minVariant.salePrice">
                      <span class="text-decoration-line-through text-muted me-1">
                        ৳ {{ product.minVariant.price }}
                      </span>
                      <span>৳ {{ product.minVariant.salePrice }}</span>
                    </span>
                    <span v-else>৳ {{ product.minVariant.price }}</span>
                  </div>
                  <!-- Product actions-->
                  <div
                    class="card-footer p-0 pb-4 pt-0 border-top-0 bg-transparent"
                  >
                    <div class="text-center">
                      <span
                        class="btn btn-outline-dark btn-sm mt-auto me-1 text-uppercase"
                        style="font-size: 10px"
                        @click="addToCart(product)"
                      >
                        <i class="bi bi-cart3"></i> Add to cart
                      </span>
                      <span
                        class="btn btn-outline-dark btn-sm mt-auto me-1 text-uppercase"
                        style="font-size: 10px"
                        @click="addToWishlist(product)"
                      >
                        <i class="bi bi-suit-heart"></i>
                      </span>
                      <span
                        class="btn btn-outline-dark btn-sm mt-auto text-uppercase"
                        style="font-size: 10px"
                        @click="addToCompare(product)"
                      >
                        <i class="bi bi-arrow-left-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center mt-5">
              <p>No products available.</p>
            </div>
          </div>
          <!-- Pagination -->
          <div
            v-if="totalPages > 1"
            class="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center my-4"
          >
            <!-- <p>Total Products: {{ totalProducts }}</p> -->
            <nav class="overflow-auto">
              <ul class="pagination mb-0 d-flex align-items-center">
                <li
                  class="page-item me-1"
                  :class="{ disabled: currentPage === 1 }"
                >
                  <button
                    class="page-link page-count"
                    @click="changePage(currentPage - 1)"
                  >
                    <i class="bi bi-arrow-left"></i>
                  </button>
                </li>
                <li
                  class="page-item mx-1"
                  v-for="(page, index) in visiblePages"
                  :key="index"
                >
                  <button
                    v-if="page !== '...'"
                    class="page-link page-count"
                    :class="{ active: page === currentPage }"
                    @click="changePage(page)"
                  >
                    {{ page }}
                  </button>
                  <span v-else class="page-link bg-transparent border-0 disabled fw-bolder">...</span>
                </li>
                <li
                  class="page-item me-1"
                  :class="{ disabled: currentPage === totalPages }"
                >
                  <button
                    class="page-link page-count"
                    @click="changePage(currentPage + 1)"
                  >
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL, BASE_IMAGE_PREFIX, PLACEHOLDER_IMAGE } from "@/globals";
// import SearchSection from "@/components/SearchSection.vue";
import { analytics } from '@/services/analytics';

export default {
  // components: { SearchSection },
  name: "SearchPage",
  data() {
    return {
      BASE_IMAGE_PREFIX,
      PLACEHOLDER_IMAGE,
      searchQuery: null,
      categoryQuery: null,
      brandQuery: null,
      isLoading: false,
      searchTimeout: null,
      searchSuggestions: [],
      showSuggestions: true,
      productList: [],
      categories: [
        {
          name: "Cleansers",
          icon: "bi bi-droplet",
          slug: "cleansers",
        },
        {
          name: "Face Serums",
          icon: "bi bi-eyedropper",
          slug: "face_serums",
        },
        {
          name: "Moisturizer",
          icon: "bi bi-moisture",
          slug: "moisturizer",
        },
        {
          name: "Sunscreen",
          icon: "bi bi-sun",
          slug: "sunscreen",
        },
        {
          name: "Toners",
          icon: "bi bi-water",
          slug: "toners",
        },
        {
          name: "Face Masks",
          icon: "bi bi-stars",
          slug: "face_masks",
        },
        {
          name: "Acne Care",
          icon: "bi bi-shield-check",
          slug: "acne_care",
        },
        {
          name: "Anti-Aging",
          icon: "bi bi-hourglass-split",
          slug: "anti_aging",
        },
        {
          name: "Body Care",
          icon: "bi bi-heart",
          slug: "body_care",
        },
        {
          name: "Lip Care",
          icon: "bi bi-emoji-kiss",
          slug: "lip_care",
        },
      ],
      concerns: [
        { label: "Acne", slug: "acne" },
        { label: "Dullness", slug: "dullness" },
        { label: "Dryness", slug: "dryness" },
        { label: "Uneven Skintone", slug: "uneven-skintone" },
        { label: "Blackheads", slug: "blackheads" },
        { label: "Hyperpigmentation", slug: "hyperpigmentation" },
      ],
      PRICE_MIN: 0,
      PRICE_MAX: 10000,
      minPrice: 0,
      maxPrice: 10000,
      currentPage: 1,
      totalPages: 1,
      totalProducts: 0,
      limit: 20,
    };
  },
  computed: {
    wishlistItemCount() {
      return this.$store.getters.wishlistItemCount;
    },
    activeTrackStyle() {
      const range = this.PRICE_MAX - this.PRICE_MIN;
      const left = ((this.minPrice - this.PRICE_MIN) / range) * 100;
      const right = ((this.PRICE_MAX - this.maxPrice) / range) * 100;
      return { left: `${left}%`, right: `${right}%` };
    },
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = 1;

      let start = Math.max(1, current - delta);
      let end = Math.min(total, current + delta);
      let pages = [];

      if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push("...");
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < total) {
        if (end < total - 1) pages.push("...");
        pages.push(total);
      }

      return pages;
    }
  },
  mounted() {
    this.searchQuery = this.$route.query.b || null;
    this.categoryQuery = this.$route.query.c || null;
    this.brandQuery = this.$route.query.a || null;
    const pageFromUrl = parseInt(this.$route.query.page, 10);
    this.currentPage = pageFromUrl > 0 ? pageFromUrl : 1;
    this.search();
    window.scrollTo(0, 0);
  },
  beforeRouteUpdate(to, from, next) {
    this.searchQuery = to.query.b || null;
    this.categoryQuery = to.query.c || null;
    this.brandQuery = to.query.a || null;

    const pageFromUrl = parseInt(to.query.page, 10);
    this.currentPage = pageFromUrl > 0 ? pageFromUrl : 1;

    this.search();
    next();
  },
  methods: {
    async search() {
      this.isLoading = true;
      try {
        // const response = await axios.get(`${BASE_URL}/api/products`, {
        //   params: {
        //     q: this.searchQuery?.trim() || undefined,
        //     category: this.categoryQuery ? this.categoryQuery : undefined,
        //     brand: this.brandQuery ? this.brandQuery : undefined,
        //   },
        // });

        // this.productList = response.data.products;
        // this.searchSuggestions = [];

        const response = await axios.get(`${BASE_URL}/api/products`, {
          params: {
            q: this.searchQuery?.trim() || undefined,
            category: this.categoryQuery || undefined,
            Brand: this.brandQuery || undefined,
            minPrice: this.minPrice > this.PRICE_MIN ? this.minPrice : undefined,
            maxPrice: this.maxPrice < this.PRICE_MAX ? this.maxPrice : undefined,
            page: this.currentPage,
            limit: this.limit,
            hasActiveVariant: true,
          },
        });

        this.productList = response.data.products;
        this.totalPages = response.data.totalPages;
        this.totalProducts = response.data.totalProducts;
        this.searchSuggestions = [];
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchSuggestions() {
      this.showSuggestions = true;
      try {
        const response = await axios.get(`${BASE_URL}/api/products`, {
          params: {
            q: this.searchQuery?.trim() || undefined,
            category: this.categoryQuery ? this.categoryQuery : undefined,
            brand: this.brandQuery ? this.brandQuery : undefined,
            hasActiveVariant: true,
          },
        });

        this.searchSuggestions = response.data.products;
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.isLoading = false;
      }
    },
    updateSearchQuery() {
      this.$router.push({
        path: "/search",
        query: this.searchQuery?.trim() ? { b: this.searchQuery } : {},
      });
    },
    selectResult(product) {
      this.$router.push(`/product/${product._id}`);
    },
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      if (this.searchQuery.trim()) {
        this.searchTimeout = setTimeout(() => {
          this.fetchSuggestions();
        }, 500);
      }
    },
    addToCart(product) {
      const cartItem = {
        product: product,
        quantity: 1,
        variant: product.minVariant
      };

      this.$store.dispatch("addToCart", cartItem);

      this.$root.showToast({
        message: "Item added to cart",
        status: "success",
        duration: 3000,
      });
      analytics.addToCart(product,
        product.minVariant.salePrice || product.minVariant.price, 1)
    },
    addToWishlist(product) {
      const wishedItem = {
        ...product,
        quantity: 1,
        variant: product.minVariant
      };
      this.$store.dispatch("addToWishlist", wishedItem);
      this.$root.showToast({
        message: "Item added to wishlist",
        status: "success",
        duration: 3000,
      });
      analytics.addToWishlist(product,
        product.minVariant.salePrice || product.minVariant.price, 1)
    },
    addToCompare(product) {
      const compareItems = this.$store.getters.compareItems;
      if (compareItems.includes(product._id)) {
        this.$root.showToast({
          message: "Product is already in compare list",
          status: "error",
          duration: 3000,
        });
        return;
      }
      if (compareItems.length >= 2) {
        this.$root.showToast({
          message: "Maximum 2 items can be compared at a time",
          status: "error",
          duration: 3000,
        });
        return;
      }
      this.$store.dispatch("addToCompare", product._id);
      this.$root.showToast({
        message: "Item added to compare",
        status: "success",
        duration: 3000,
      });
    },
    onMinInput() {
      if (this.minPrice > this.maxPrice) {
        this.minPrice = this.maxPrice;
      }
    },
    onMaxInput() {
      if (this.maxPrice < this.minPrice) {
        this.maxPrice = this.minPrice;
      }
    },
    applyPriceFilter() {
      this.currentPage = 1;
      this.search();
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: page
        }
      });
      this.search();
    },
    slugify(text) {
      return text
        .toString()                  // convert to string
        .normalize("NFD")            // normalize accents (café → cafe)
        .replace(/[\u0300-\u036f]/g, "") // remove diacritics
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "") // remove invalid chars
        .replace(/\s+/g, "-")         // collapse whitespace and replace by -
        .replace(/-+/g, "-");         // collapse dashes
    },
  },
};
</script>

<style lang="scss" scoped>
/* ################## */

/* Search Section */

.search-section {
  padding: 15px 0;
  .search-box {
    position: relative;
    .search-icon {
      position: absolute;
      top: 15px;
      right: 30px;
      font-size: 20px;
      cursor: pointer;
    }
    .search-icon:hover {
      color: var(--primary-color);
    }
  }
}

.categories-toggle {
  color: var(--light-pink);
  background-color: var(--primary-color);
  border: none;
  padding: 10px 50px;
  font-size: 20px;
  font-weight: 300;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 50px;
}

.search-input {
  border-radius: 30px;
  padding: 12px 25px;
  border: none;
  width: 100%;
  background: #f1f0f0;
}

.search-result-wrapper {
  position: relative;
  .search-dropdown {
    position: absolute;
    width: 100%;
    background: white;
    border: 1px solid #ddd;
    border-radius: 10px;
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 5px 0 0 0;
    z-index: 5;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .search-dropdown li {
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    .suggestion-product-image {
      width: auto;
      height: 40px;
      border-radius: 5px;
      margin-right: 10px;
      object-fit: cover;
    }
  }

  .search-dropdown li:hover {
    background: #f0f0f0;
  }
}

.store-locator {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

@media (max-width: 767px) {
  .categories-toggle {
    display: none;
  }
}

.category-text {
  font-size: 15px;
  font-weight: 400;
  color: #333;
}

.category-text:hover {
  opacity: 0.8;
  color: var(--primary-color);
}

.category-icon {
  margin-right: 5px;
  opacity: 0.5;
  font-size: 18px;
}

.category-link:hover .category-icon {
  opacity: 1;
}

/* Product Grid */
.product-tabs {
  border-bottom: none;
  margin-bottom: 30px;
}

.product-tabs .nav-link {
  color: var(--text-gray);
  border: none;
  padding: 10px 20px;
  font-weight: 500;
}

.product-tabs .nav-link.active {
  color: var(--primary-color);
  background: none;
  position: relative;
}

.product-tabs .nav-link.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 2px;
  background-color: var(--primary-color);
}

.product-card {
  background: white;
  border-radius: 8px;
  padding: 0 20px 0 0;
  text-align: center;
  transition: transform 0.3s;
  position: relative;
  /* box-shadow: 0 2px 10px rgba(0,0,0,0.05); */
}

.product-card::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #ccc;
  opacity: 0.3;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  width: 100%;
  height: auto;
  border-radius: 15px;
  margin-bottom: 15px;
}

.product-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-brand {
  color: var(--text-gray);
  font-size: 14px;
  margin-bottom: 8px;
}

.product-rating {
  color: #ffc107;
  margin-bottom: 8px;
}

.product-price {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 18px;
}

// Filters
.filter-section {
  .card {
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 15px;
    .top-product-item {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;
      text-decoration: none;
      color: inherit;
      transition: transform 0.2s;
      position: relative;
    }

    .top-product-item:hover {
      transform: translateX(5px);
    }

    .top-product-cover {
      width: 80px;
      height: 120px;
      object-fit: cover;
      border-radius: 8px;
      flex-shrink: 0;
    }

    .top-product-info {
      flex-grow: 1;
    }

    .top-product-title {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 4px;
      color: #333;
    }

    .top-product-brand,
    .top-product-price {
      font-size: 14px;
      color: #666;
    }
  }

  .filter-title {
    font-size: 24px;
    font-weight: 600;
    color: #000;
  }

  .price-filter {
    .price-values {
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }

    .range-slider {
      position: relative;
      height: 24px;

      .range-track,
      .range-track-active {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: 4px;
        border-radius: 4px;
      }

      .range-track {
        left: 0;
        right: 0;
        background: #e2e2e2;
      }

      .range-track-active {
        background: var(--secondary-color);
      }

      .range-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 24px;
        margin: 0;
        background: none;
        pointer-events: none;
        -webkit-appearance: none;
        appearance: none;

        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          pointer-events: auto;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #fff;
          border: 2px solid var(--secondary-color);
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        }

        &::-moz-range-thumb {
          pointer-events: auto;
          width: 18px;
          height: 18px;
          border: 2px solid var(--secondary-color);
          border-radius: 50%;
          background: #fff;
          cursor: pointer;
        }
      }
    }

    .apply-filter-btn {
      background-color: var(--secondary-color);
      color: #fff;
      font-weight: 500;
      border: none;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .filter-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .custom-checkbox {
    margin: 0;

    .form-check-input {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      border: 2px solid #ddd;
      border-radius: 4px;
      cursor: pointer;

      &:checked {
        background-color: #0d6efd;
        border-color: #0d6efd;
      }
    }

    .form-check-label {
      font-size: 16px;
      color: #333;
      cursor: pointer;
      user-select: none;
    }
  }
}

.page-count {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  border: none;
  background-color: #f8f9fa;
  color: #333;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e2e6ea;
    cursor: pointer;
  }

  &.active,
  &:focus {
    background-color: var(--primary-color);
    color: white;
  }
}

@media (max-width: 991px) {
  .page-count {
    width: 30px;
    height: 30px;
    font-size: 10px;
  }
}
</style>

